/**
 * Sơ đồ tách rời ("exploded view" / sơ đồ lắp đặt) — thuật toán TOẢ TÂM (center-scaling):
 * mỗi chi tiết dời theo vector từ TÂM model ra tâm chính nó, nhân `mức` (0..1). Chi tiết càng xa
 * tâm càng tách xa → giữ nguyên bố cục tương đối (nóc lên, đáy xuống, hông ra 2 bên, hậu lùi…).
 * Chạy cho MỌI geometry vì chỉ cần `partCenter` (xem MeshBuilder.partCenter).
 *
 * Tách tầng khỏi chuyển động: SceneManager áp offset này lên GROUP BAO NGOÀI pivot, không đụng
 * `pivot.position` (do MotionEngine sở hữu mỗi frame) → explode cộng hưởng sạch với cửa/ngăn kéo.
 */
import { Vector3 } from 'three';

/** Mức 100% = chi tiết ở rìa dời bằng 1.5× khoảng cách của nó tới tâm (tổng trải ~2.5×). */
export const EXPLODE_MAX = 1.5;

/**
 * Vector tách rời (scene units) cho 1 chi tiết.
 * @param partCenter tâm chi tiết (scene units) — bất biến theo chuyển động.
 * @param modelCenter tâm khung bao toàn model (scene units), lúc lắp ráp.
 * @param amount01 mức tách rời 0..1 (kẹp biên); 0 = lắp ráp, 1 = tối đa.
 * @param out tái dùng để tránh cấp phát mỗi frame.
 */
export function explodeOffset(
  partCenter: Vector3,
  modelCenter: Vector3,
  amount01: number,
  out: Vector3 = new Vector3(),
): Vector3 {
  const k = Math.max(0, Math.min(1, amount01)) * EXPLODE_MAX;
  return out.subVectors(partCenter, modelCenter).multiplyScalar(k);
}
